export type { ButtonProps } from "@components/contracts/Button.types";
export { CelebrationButton } from "./Button.adapter";
